import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Trans, useTranslation } from 'react-i18next';

// assets
import googleStore from '../Assets/Images/google-play.png';
import appleStore from '../Assets/Images/app-store.png';
import logoEn from '../Assets/Images/logo-en.png';
import logoAr from '../Assets/Images/logo-ar.png';

// components
import LanguageBtn from './LanguageBtn';
import Location from '../Assets/Icons/Footer/location.svg';
import Mobile from '../Assets/Icons/Footer/mobile.svg';
import Email from '../Assets/Icons/Footer/email.svg';
import Facebook from '../Assets/Icons/Footer/facebook.svg';
import Instagram from '../Assets/Icons/Footer/instagram.svg';
import LinkedIn from '../Assets/Icons/Footer/linkedin.svg';
import TikTok from '../Assets/Icons/Footer/tiktok.svg';
import Youtube from '../Assets/Icons/Footer/youtube.svg';
import BrandGreen from '../Assets/Images/brand-green.svg';

const Footer = ({ onOpenTermsModal }) => {
  const { language } = useSelector((state) => state.lang);
  const { t } = useTranslation();
  const location = useLocation();
  // const dir = language === 'ar' ? 'rtl' : 'ltr';
  const quickLinks = [
    { key: 1, name: t('header.menu.nav.home'), link: '/home' },
    { key: 2, name: t('header.menu.nav.solutions'), link: '/solutions' },
    { key: 3, name: t('header.menu.nav.collectionCenter'), link: '/stores' },
    { key: 4, name: t('header.menu.nav.materials'), link: '/supply-prices' },
    { key: 5, name: t('privacyPolicy.title'), link: '/privacy-policy' },
  ];
  const socialLinks = [
    {
      key: 1,
      link: 'https://www.facebook.com/share/159gTMWW4o/?mibextid=wwXIfr',
      icon: Facebook,
      title: 'Facebook',
    },
    {
      key: 2,
      link: 'https://www.instagram.com/bigscrappers.eg?igsh=MW5pNzZmNDN3dGdibQ==',
      icon: Instagram,
      title: 'Instagram',
    },
    {
      key: 3,
      link: 'https://www.linkedin.com/company/big-scrappers/',
      icon: LinkedIn,
      title: 'LinkedIn',
    },
    {
      key: 4,
      link: 'https://www.tiktok.com/@big.scrappers?_t=ZS-8t01QuQjQ5y&_r=1',
      icon: TikTok,
      title: 'TikTok',
    },
    {
      key: 5,
      link: 'https://www.youtube.com/@kabnouryholding',
      icon: Youtube,
      title: 'Youtube',
    },
  ];

  const handleChangingPath = (path) => {
    if (location.pathname === path) {
      window.scrollTo(0, 0);
    }
  };

  const cursorStyle = {
    cursor: 'text',
  };

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__links">
          <h4>{t('footer.quickLinks')}</h4>
          <ul>
            {quickLinks.map((ele) => (
              <li key={ele.key} onClick={() => handleChangingPath(ele.link)}>
                <Link to={ele.link}>{ele.name}</Link>
              </li>
            ))}
            <li onClick={onOpenTermsModal}>{t('header.menu.nav.terms')}</li>
            <li>
              <LanguageBtn title={t('header.menu.nav.language')} />
            </li>
          </ul>
        </div>
        <div className="footer__getin">
          <h4>{t('footer.getIn.title')}</h4>
          <ul>
            <li style={cursorStyle}>
              <img src={Location} alt="location" loading="lazy" />
              {t('footer.getIn.address')}
            </li>
            <li style={cursorStyle}>
              <img src={Mobile} alt="mobile" loading="lazy" />
              {t('footer.getIn.phone')}
            </li>
            <li>
              <img src={Email} alt="email" loading="lazy" />
              <a href={`mailto:${t('footer.getIn.email')}`}>
                {t('footer.getIn.email')}
              </a>
            </li>
          </ul>
          <div className="footer__download">
            <p>{t('footer.getIn.download')}</p>
            <div className="footer__download--social">
              <a
                href="https://apps.apple.com/eg/app/big-scrappers/id6557068840"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={appleStore}
                  alt="apple store"
                  className="d-block img-fluid"
                  loading="lazy"
                />
              </a>

              <a
                href="https://play.google.com/store/apps/details?id=com.nationtech.bigscrappers"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={googleStore}
                  alt="google store"
                  className="d-block img-fluid"
                  loading="lazy"
                />
              </a>
            </div>
          </div>
        </div>
        <div className="footer_social">
          <h4>{t('footer.followUs')}</h4>
          <ul>
            {socialLinks.map((link) => {
              return (
                <Link key={link.key} to={link.link} target="_blank">
                  <img src={link.icon} alt={link.title} loading="lazy" />
                </Link>
              );
            })}
          </ul>
        </div>
      </div>
      <div className="footer__bottom">
        <Link to="/home">
          <img src={BrandGreen} alt="brand" loading="lazy" />
        </Link>
        <div>
          <Trans
            i18nKey="footer.copyRights"
            components={{
              green: (
                <span
                  style={{
                    color: '#32cd32',
                    fontWeight: '500',
                    textDecoration: 'underline',
                  }}
                />
              ),
            }}
          />
        </div>
      </div>
    </footer>
    // <footer dir={dir} className="footer" style={{ backgroundColor: '#1A1A1A' }}>
    //   <div className="footer__holder mx-auto">
    //     <ul className="footer__holder__nav-links d-flex flex-wrap align-items-center justify-content-center list-unstyled">
    //       {navLinks.map((ele) => (
    //         <li
    //           key={ele.key}
    //           className={`${language === 'ar' ? 'lang--ar' : 'lang--en'}`}
    //         >
    //           {ele.link ? (
    //             <Link
    //               to={ele.link}
    //               onClick={() => handleChangingPath(ele.link)}
    //               className="text--white fsize--6 text-capitalize fw-bold"
    //             >
    //               {ele.name}
    //             </Link>
    //           ) : (
    //             <button
    //               type="button"
    //               onClick={onOpenTermsModal}
    //               className="bg-transparent border-0 outline-none shadow-none text--white fsize--6 text-capitalize fw-bold"
    //             >
    //               {ele.name}
    //             </button>
    //           )}
    //         </li>
    //       ))}
    //       <li>
    //         <LanguageBtn />
    //       </li>
    //     </ul>
    //     <div dir="ltr" className="row m-0 flex-column-reverse flex-xl-row">
    //       <div className="footer__holder__copy-rights-col col-xl-6 px-0 d-flex justify-content-center justify-content-xl-start">
    //         <div className="d-flex flex-column">
    //           <img
    //             src={language === 'ar' ? logoAr : logoEn}
    //             alt="Big Scrappers logo"
    //             className="footer__holder__copy-rights-col__logo img-fluid d-block mx-auto"
    //           />
    //           <p
    //             className="text--white text-center fsize--6 fw-bold mb-0"
    //             style={{ width: language === 'hr' ? 'max-content' : '' }}
    //           >
    //             {t('footer.bigScrappersWebsite')} <br /> 2024
    //           </p>
    //           <ul className="footer__holder__social-links d-flex align-items-center justify-content-center mb-0 list-unstyled">
    //             {socialLinks.map((ele) => (
    //               <li key={ele.key}>
    //                 <Link
    //                   to={ele.link}
    //                   aria-label={`${ele.label} Link`}
    //                   target="_blank"
    //                 >
    //                   <img
    //                     src={ele.icon}
    //                     alt={ele.label}
    //                     className="d-block img-fluid"
    //                   />
    //                 </Link>
    //               </li>
    //             ))}
    //           </ul>
    //         </div>
    //       </div>
    //       <div className="footer__holder__get-app-links-col col-xl-6 px-0 d-flex justify-content-center justify-content-xl-end">
    //         <div className="footer__holder__get-app-links-col__holder d-flex flex-column align-items-center">
    //           <p className="text--white fsize--7 fw-bold text-center mb-0">
    //             {t('home.thirdSection.getApplication')}
    //           </p>
    //           <a
    //             href="https://play.google.com/store/apps/details?id=com.nationtech.bigscrappers"
    //             target="_blank"
    //             rel="noopener noreferrer"
    //           >
    //             <img src={googleStore} alt="" className="d-block img-fluid" />
    //           </a>
    //           <a
    //             href="https://apps.apple.com/eg/app/big-scrappers/id6557068840"
    //             target="_blank"
    //             rel="noopener noreferrer"
    //           >
    //             <img src={appleStore} alt="" className="d-block img-fluid" />
    //           </a>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </footer>
  );
};

export default Footer;
